import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const USDSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99991 3C9.63747 3 9.34366 3.29381 9.34366 3.65625V4.65484C7.59165 4.88441 6.42074 6.07822 6.44215 7.56525C6.44138 8.89111 7.42348 9.61915 8.2547 10.0057C8.60591 10.169 8.99717 10.2988 9.34366 10.3986V14.0327C8.0139 13.8417 7.61211 13.0027 7.5473 12.8338C7.41748 12.4954 7.03792 12.3263 6.69954 12.4561C6.36115 12.5859 6.19207 12.9655 6.32189 13.3039C6.51413 13.805 7.29248 15.1435 9.34366 15.3554V16.3438C9.34366 16.7062 9.63747 17 9.99991 17C10.3623 17 10.6562 16.7062 10.6562 16.3438V15.3386C11.3733 15.2485 12.0305 15.0216 12.5581 14.6369C13.287 14.1054 13.7207 13.3041 13.7218 12.3084L13.7218 12.3009L13.7217 12.2935C13.6991 11.2404 13.1463 10.5587 12.4927 10.1298C11.9003 9.74122 11.1934 9.53882 10.7134 9.4014L10.662 9.38668C10.6601 9.38608 10.6581 9.38548 10.6562 9.38488V5.9778C11.0575 6.04364 11.3494 6.16694 11.5632 6.30605C11.8864 6.51628 12.0811 6.79492 12.2018 7.08197C12.3423 7.41606 12.727 7.57299 13.0611 7.43249C13.3952 7.29198 13.5522 6.90724 13.4116 6.57315C13.2096 6.09283 12.8629 5.58574 12.279 5.20586C11.846 4.92419 11.3101 4.73038 10.6562 4.65273V3.65625C10.6562 3.29381 10.3623 3 9.99991 3ZM9.34366 5.98003C8.2192 6.18142 7.74411 6.92339 7.75457 7.54977L7.75468 7.55624L7.75466 7.5627C7.75304 8.10308 8.11996 8.49556 8.80816 8.81561C8.99016 8.90025 9.16958 8.96947 9.34366 9.02803V5.98003ZM10.6562 10.7526V14.0125C11.1251 13.9337 11.5055 13.78 11.7848 13.5764C12.1751 13.2918 12.4066 12.8854 12.4093 12.3144C12.396 11.7963 12.1542 11.4775 11.7727 11.2273C11.4498 11.0154 11.0573 10.8745 10.6562 10.7526Z"
        fill="#888888"
      />
    </svg>
  );
};
